import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const LibraryCodeIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M7.53 5.47C7.24 5.18 6.76 5.18 6.47 5.47L0.470002 11.47C0.180002 11.76 0.180002 12.24 0.470002 12.53L6.47 18.53C6.76 18.82 7.24 18.82 7.53 18.53C7.82 18.24 7.82 17.76 7.53 17.47L2.06 12L7.53 6.53C7.82 6.24 7.82 5.76 7.53 5.47Z"
        fill={color}
      />
      <path
        d="M23.72 11.46L17.52 5.46C17.22 5.17 16.75 5.18 16.46 5.48C16.17 5.78 16.18 6.25 16.48 6.54L22.12 12L16.48 17.46C16.18 17.75 16.17 18.22 16.46 18.52C16.75 18.82 17.22 18.83 17.52 18.54L23.72 12.54C24.02 12.26 24.02 11.74 23.72 11.46Z"
        fill={color}
      />
      <path
        d="M14.18 3.27001C13.78 3.17001 13.37 3.41001 13.27 3.82001L9.27001 19.82C9.17001 20.22 9.41001 20.63 9.82001 20.73C10.21 20.83 10.63 20.59 10.73 20.18L14.73 4.18001C14.83 3.78001 14.59 3.37001 14.18 3.27001Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

LibraryCodeIcon.displayName = 'LibraryCodeIcon';
